import {
	NgModule,
	CUSTOM_ELEMENTS_SCHEMA,
	ModuleWithProviders,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnPaginationModule } from '../pagination/index';
import { FnInputModule } from './../input/index';
import { FoundationModule } from '../../foundation.module';

import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';

import { FnGridComponent } from './fn-grid.component';
import { FnGridSearchComponent } from './search/fn-grid.search.component';
import { FnGridCellComponent } from './grid-cell/fn-grid-cell.component';
import { FnGridColorComponent } from './grid-component/fn-grid-color/fn-grid-color.component';
import { FnGridCurrencyComponent } from './grid-component/fn-grid-currency/fn-grid-currency.component';
import { FnGridEmailComponent } from './grid-component/fn-grid-email/fn-grid-email.component';
import { FnGridImgComponent } from './grid-component/fn-grid-img/fn-grid-img.component';
import { FnGridNumberComponent } from './grid-component/fn-grid-number/fn-grid-number.component';
import { FnGridPhoneNumberComponent } from './grid-component/fn-grid-phone-number/fn-grid-phone-number.component';
import { FnGridTextComponent } from './grid-component/fn-grid-text/fn-grid-text.component';
import { FnGridDateComponent } from './grid-component/fn-grid-date/fn-grid-date.component';
import { FnGridExportComponent } from './export/fn-grid-export.component';
import { FnGridNumberFilterComponent } from './grid-component/fn-grid-filters/fn-grid-number-filter/fn-grid-filter.component';
import { FnComponentRenderService } from './services/fn-component-render.service';
import { FnTranslateModule } from './../../i18n/index';

import { FnCoreModule } from '../../core/index';
import { FnGridService } from './services/fn-grid.service';
import { FnGridRattingComponent } from './grid-component/fn-grid-ratting/fn-grid-ratting.component';
import { FnGridLookupComponent } from './grid-component/fn-grid-lookup/fn-grid-lookup.component';
import { FnGridBooleanComponent } from './grid-component/fn-grid-boolean/fn-grid-boolean.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FnGridGlobalService } from './services/fn-grid-global.service';
import { FnSwitchModule } from '../switch/index';
import { FnColorPickerModule } from '../color-picker/index';

import { FnGridHeaderFilterComponent } from './grid-component/fn-grid-filters/fn-grid-header-filter/fn-grid-header-filter.component';
import { FnGridColumnPinFilterComponent } from './grid-component/fn-grid-filters/fn-grid-column-pin-filter/fn-grid-column-pin-filter.component';
import { FnGridColumnSearchFilterComponent } from './grid-component/fn-grid-filters/fn-grid-column-search-filter/fn-grid-column-search-filter.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FnGridCheckSelectFilterComponent } from './grid-component/fn-grid-filters/fn-grid-check-select-filter/fn-grid-check-select-filter.component';
import { FnScrollbarModule } from '../scrollbar/index';
import { FnGridLookupService } from './services/fn-grid-lookup.service';
import { FnGridCellGroupComponent } from './grid-cell-group/fn-grid-cell-group.component';
import { FnNoDataBoxModule } from '../fn-no-data-box/index';

export * from './model/index';
export * from './services/fn-grid.service';
export * from './services/fn-component-render.service';
export * from './services/fn-grid-global.service';
export * from './services/fn-grid-lookup.service';

export * from './fn-grid.component';
export * from './search/fn-grid.search.component';
export * from './grid-cell/fn-grid-cell.component';
export * from './export/fn-grid-export.component';

export * from './grid-component/fn-grid-color/fn-grid-color.component';
export * from './grid-component/fn-grid-currency/fn-grid-currency.component';
export * from './grid-component/fn-grid-email/fn-grid-email.component';
export * from './grid-component/fn-grid-img/fn-grid-img.component';
export * from './grid-component/fn-grid-number/fn-grid-number.component';
export * from './grid-component/fn-grid-phone-number/fn-grid-phone-number.component';
export * from './grid-component/fn-grid-text/fn-grid-text.component';
export * from './grid-component/fn-grid-date/fn-grid-date.component';
export * from './grid-component/fn-grid-filters/fn-grid-number-filter/fn-grid-filter.component';

export * from './grid-component/fn-grid-ratting/fn-grid-ratting.component';
export * from './grid-component/fn-grid-lookup/fn-grid-lookup.component';
export * from './grid-component/fn-grid-boolean/fn-grid-boolean.component';

export * from './services/fn-component-render.service';
export * from './grid-component/fn-grid-filters/fn-grid-header-filter/fn-grid-header-filter.component';
export * from './grid-component/fn-grid-filters/fn-grid-column-pin-filter/fn-grid-column-pin-filter.component';
export * from './grid-component/fn-grid-filters/fn-grid-column-search-filter/fn-grid-column-search-filter.component';
export * from './grid-component/fn-grid-filters/fn-grid-check-select-filter/fn-grid-check-select-filter.component';
export * from './grid-cell-group/fn-grid-cell-group.component';

const TABLE_COMPONENT_LIST = [
	FnGridComponent,
	FnGridSearchComponent,
	FnGridCellComponent,
	FnGridExportComponent,
	FnGridColorComponent,
	FnGridCurrencyComponent,
	FnGridDateComponent,
	FnGridEmailComponent,
	FnGridImgComponent,
	FnGridNumberComponent,
	FnGridPhoneNumberComponent,
	FnGridTextComponent,
	FnGridNumberFilterComponent,
	FnGridRattingComponent,
	FnGridLookupComponent,
	FnGridBooleanComponent,
	FnGridDateComponent,
	FnGridCellGroupComponent,
	FnGridHeaderFilterComponent,
	FnGridColumnPinFilterComponent,
	FnGridColumnSearchFilterComponent,
	FnGridCheckSelectFilterComponent,
];

@NgModule({ declarations: [TABLE_COMPONENT_LIST],
    exports: [TABLE_COMPONENT_LIST],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
        CommonModule,
        FnPaginationModule,
        FoundationModule,
        FnTranslateModule,
        FnCoreModule,
        MatMenuModule,
        FnSwitchModule,
        FnColorPickerModule,
        NgbDropdownModule,
        MatTabsModule,
        FnInputModule,
        FnScrollbarModule,
        FnNoDataBoxModule], providers: [
        FnGridService,
        FnGridGlobalService,
        FnComponentRenderService,
        FnGridLookupService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class FnGridModule {
	static forRoot(): ModuleWithProviders<FnGridModule> {
		return {
			ngModule: FnGridModule,
			providers: [
				FnGridService,
				FnGridGlobalService,
				FnComponentRenderService,
				FnGridLookupService,
			],
		};
	}
}
